
import Vue from 'vue';
import MenuOrBottomSheet from '@/components/base/MenuOrBottomSheet.vue';
import { isLightHexColor } from '@run-diffusion/shared';

export default Vue.extend({
	name: 'ColorInput',
	props: {
		value: { type: String, default: null },
		clearable: { type: Boolean, default: false },
		disabled: { type: Boolean, default: false },
		iconSize: { type: Number, default: 24 },
		hideLabel: { type: Boolean, default: false },
	},
	data () {
		return {
			isOpen: false,
			colors: [
				'#ffffff', // White
				'#d32f2f', // Dark Red
				'#e91e63', // Pink
				'#9c27b0', // Purple
				'#673ab7', // Deep Purple
				'#3f51b5', // Indigo
				'#1e88e5', // Dark Blue
				'#00acc1', // Dark Cyan
				'#009688', // Teal
				'#4caf50', // Green
				'#ff9800', // Bright Orange
				'#ff5722', // Deep Orange
				'#a0522d', // Sienna
				'#4e342e', // Dark Brown
				'#607d8b', // Blue Grey
				'#424242', // Grey
				'#272727', // Dark Grey
			],
		};
	},
	computed: {
		textColor () {
			const color: string = this.value || '#000000'; // Default to black if no color
			return isLightHexColor(color) ? 'var(--grey-900) !important' : 'var(--grey-200) !important';
		},
	},
	methods: {
		onInput (val: string) {
			this.$emit('input', val);
			if (val !== this.value) {
				this.isOpen = false;
			}
		},
	},
	components: {
		MenuOrBottomSheet,
	},
});
